<template>
  <div>
    <div style="display:flex;justify-content: space-between;">
      <div style="display:flex;gap:10px">
        <div style="display: flex; flex-direction: row-reverse; gap: 0px; align-items: end;">
          <p style="margin-bottom: 0px; font-weight: bold;">
            {{ $t('Internal') }}
          </p>
          <span style="width:30px;height:30px;border-radius: 50%;font-weight:normal;background-color: rgb(143, 188, 143); color: black; text-align: left; flex: 1; margin-right: 10px;padding: 7px;" />
        </div>
        <div style="display: flex; flex-direction: row-reverse; gap: 0px; align-items: end;">
          <p style="margin-bottom: 0px; font-weight: bold;">
            {{ $t('External') }}
          </p>
          <span style="width:30px;height:30px;border-radius: 50%;font-weight:normal;background-color: rgb(255, 215, 0); color: black; text-align: left; flex: 1; margin-right: 5px;padding: 7px;" />
        </div>
        <div
          style="display: flex;align-items:end"
        >
          <div style="display:flex; flex-direction: column;">
            <div style="display: flex; height: 30px;margin-left: 10px;">
              <div style="background-color: #d82521; width: 25px; height: 25px; margin-right: 10px;" />
              <p>
                {{ $t('lessStaff') }}
              </p>
            </div>
            <div style="display: flex;height: 30px; margin-left: 10px;">
              <div style="background-color: #347403; width: 25px; height: 25px; margin-right: 10px;" />
              {{ $t('equalStaff') }}
            </div>

          </div>
          <div style="display: flex;height: 30px; margin-left: 10px;">
            <div style="background-color:#ff9b00; width: 25px; height: 25px; margin-right: 10px;" />
            {{ $t('moreStaff') }}
          </div>
        </div>
      </div>
      <b-form-group
        :label="$t('Date')"
      >
        <div style="display:flex;gap:5px;">
          <button
            class="buttonArrays"
            @click="previousDayForAll(startDateForAll)"
          >
            <b-icon-arrow-left />
          </button>
          <date-picker
            v-model="startDateForAll"
            type="date"
            value-type="format"
            :placeholder="$t('SelectDate')"
            :format="'YYYY-MM-DD'"
            :start-day="1"
            :lang="lang"
            :clearable="false"
          />
          <button
            class="buttonArrays"
            @click="nextDayForAll(startDateForAll)"
          >
            <b-icon-arrow-right />
          </button>
        </div>
      </b-form-group>
      <div style="display:flex;gap:10px;margin-top:10px;">
        <b-form-checkbox
          v-model="platformConforama"
          :disabled="!platformLipo && !platformMoemax && !platformPfinster"
          @change="updatePlatforms(platformConforama, 'Conforama', 'conforamaPlatform')"
        >
          {{ $t("Conforama") }}
        </b-form-checkbox>
        <b-form-checkbox
          v-model="platformLipo"
          :disabled="!platformConforama && !platformMoemax && !platformPfinster"
          @change="updatePlatforms(platformLipo, 'Lipo', 'lipoPlatform')"
        >
          {{ $t("Lipo") }}
        </b-form-checkbox>
        <b-form-checkbox
          v-model="platformMoemax"
          :disabled="!platformConforama && !platformLipo && !platformPfinster"
          @change="updatePlatforms(platformMoemax, 'Moemax', 'moemaxPlatform')"
        >
          {{ $t("Moemax") }}
        </b-form-checkbox>
        <b-form-checkbox
          v-model="platformPfinster"
          :disabled="!platformConforama && !platformLipo && !platformMoemax"
          @change="updatePlatforms(platformPfinster, 'Pfister', 'pfinsterPlatform')"
        >
          {{ $t("Pfister") }}
        </b-form-checkbox>
      </div>
    </div>
    <div
      v-show="platformConforama"
      style="margin-top: 25px;border:1px solid lightgrey;padding:10px;border-radius:12px;"
    >
      <div style="display:flex;justify-content: flex-end;align-items: center;">
        <b-form-group
          v-if="!conforamaCollapsed"
          style="width:250px"
        >
          <b-form-input
            v-model="platformConforamaName"
            disabled
          />
        </b-form-group>
        <b-icon-chevron-down
          v-if="!conforamaCollapsed"
          style="cursor:pointer; margin-left: 10px;"
          @click="toggleCollapse('conforamaCollapsed')"
        />
        <b-icon-chevron-up
          v-if="conforamaCollapsed"
          style="cursor:pointer; margin-left: 10px;"
          @click="toggleCollapse('conforamaCollapsed')"
        />
      </div>

      <b-collapse
        :visible="conforamaCollapsed"
        class="mt-2"
      >
        <div style="display: flex;justify-content: space-between;">
          <div style="display:flex; gap:10px;align-items: end;">
            <b-form-group
              :label="$t('Platform')"
              style="width:250px"
            >
              <b-form-input
                v-model="platformConforamaName"
                disabled
              />
            </b-form-group>
            <button
              v-b-modal.new-add-employee-planning
              class="button"
              style="border-radius: 6px; height: 36px; margin-top: 25px; margin-right: 20px; width:200px"
              @click="fetchStores(platformConforamaName)"
            >
              <b-icon-plus />
              {{ $t('Employee') }}
            </button>
          </div>
          <b-form-group
            :label="$t('Date')"
          >
            <div style="display:flex;gap:5px;">
              <button
                class="buttonArrays"
                @click="previousDay('startDateConforama')"
              >
                <b-icon-arrow-left />
              </button>
              <date-picker
                v-model="startDateConforama"
                type="date"
                value-type="format"
                :placeholder="$t('SelectDate')"
                :format="'YYYY-MM-DD'"
                :start-day="1"
                :lang="lang"
                :clearable="false"
              />
              <button
                class="buttonArrays"
                @click="nextDay('startDateConforama')"
              >
                <b-icon-arrow-right />
              </button>
            </div>
          </b-form-group>
        </div>
        <div
          style="overflow-x: auto;width: 100%;margin-top:10px;"
        >
          <table
            class="team_table"
            style="width: 100%; box-shadow: 0px 7px 20px rgb(40 41 61 / 8%);    border: 1px solid lightgrey; font-size: 12px;margin-top:10px;"
          >
            <thead>
              <tr
                v-if="conforamaPlatform.length > 0"
              >
                <th
                  v-for="(item, index) in conforamaPlatform"
                  :key="index"
                  class="thClass"
                  style="border-radius: 10px 0px 0px 0px;"
                >
                  <span
                    :class="{
                      'green-text': item.numberOfPlannedEmployees === item.plannedEmployees.length,
                      'orange-text': item.numberOfPlannedEmployees < item.plannedEmployees.length,
                      'red-text': item.numberOfPlannedEmployees > item.plannedEmployees.length
                    }"
                  >
                    {{ item.storeName }} - {{ item.numberOfPlannedEmployees || 0 }}
                  </span>
                </th>
              </tr>
              <tr v-else>
                <th
                  class="thClass"
                  style="border-radius: 10px 0px 0px 0px;"
                >
                  {{ $t('Store') }}
                </th>
              </tr>
            </thead>

            <tbody>
              <tr
                v-if="conforamaPlatform.length > 0"
              >
                <td
                  v-for="(item, index) in conforamaPlatform"
                  :key="index"
                  class="thClass"
                  style="border-radius: 10px 0px 0px 0px;"
                >
                  <div v-if="item.plannedEmployees.length > 0">
                    <p
                      v-for="(emplooye ,employeeIndex) in item.plannedEmployees"
                      :key="employeeIndex"
                      class="header"
                      :style="{ background: emplooye.employeeType === 'Internal' ? 'rgb(143, 188, 143)' : 'rgb(255, 215, 0)' }"
                    >
                      {{ emplooye.employeeName }}
                      <span style="display:flex;gap:5px;">
                        <b-icon-pencil-fill
                          v-b-modal.new-edit-employee-platform
                          style="cursor:pointer"
                          @click="editEmployee(emplooye, platformConforamaName, item.storeName, item.startDate, item.endDate)"
                        />
                        <b-icon-trash-fill
                          v-b-modal.new-delete-employee-platform
                          style="cursor:pointer"
                          @click="deleteEmploye(emplooye, platformConforamaName, item.storeName, item.startDate, item.endDate)"
                        />
                      </span>
                    </p>
                  </div>
                  <div
                    v-else
                    class="header"
                    style="background-color: red;color:white;"
                  >
                    <p>
                      {{ $t('NoEmployeeFound') }}
                    </p>
                  </div>
                </td>
              </tr>
              <tr v-else>
                <td
                  class="thClass"
                  style="border-radius: 10px 0px 0px 0px;"
                >
                  {{ $t('NoStoreFound') }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      </b-collapse>

    </div>

    <div
      v-show="platformLipo"
      style="margin-top: 25px;border:1px solid lightgrey;padding:10px;border-radius:12px;"
    >
      <div style="display:flex;justify-content: flex-end;align-items: center;">
        <b-form-group
          v-if="!lipoCollapsed"
          style="width:250px"
        >
          <b-form-input
            v-model="platformLipoName"
            disabled
          />
        </b-form-group>
        <b-icon-chevron-down
          v-if="!lipoCollapsed"
          style="cursor:pointer; margin-left: 10px;"
          @click="toggleCollapse('lipoCollapsed')"
        />
        <b-icon-chevron-up
          v-if="lipoCollapsed"
          style="cursor:pointer; margin-left: 10px;"
          @click="toggleCollapse('lipoCollapsed')"
        />
      </div>
      <b-collapse
        :visible="lipoCollapsed"
        class="mt-2"
      >
        <div style="display: flex;justify-content: space-between;">
          <div style="display:flex; gap:10px;align-items: end;">
            <b-form-group
              :label="$t('Platform')"
              style="width:250px"
            >
              <b-form-input
                v-model="platformLipoName"
                disabled
              />
            </b-form-group>
            <button
              v-b-modal.new-add-employee-planning
              class="button"
              style="border-radius: 6px; height: 36px; margin-top: 25px; margin-right: 20px; width:200px"
              @click="fetchStores(platformLipoName)"
            >
              <b-icon-plus />
              {{ $t('Employee') }}
            </button>
          </div>
          <b-form-group
            :label="$t('Date')"
          >
            <div style="display:flex;gap:5px;">
              <button
                class="buttonArrays"
                @click="previousDay('startDateLipo')"
              >
                <b-icon-arrow-left />
              </button>
              <date-picker
                v-model="startDateLipo"
                type="date"
                value-type="format"
                :placeholder="$t('SelectDate')"
                :format="'YYYY-MM-DD'"
                :start-day="1"
                :lang="lang"
                :clearable="false"
              />
              <button
                class="buttonArrays"
                @click="nextDay('startDateLipo')"
              >
                <b-icon-arrow-right />
              </button>
            </div>
          </b-form-group>
        </div>
        <div
          style="overflow-x: auto;width: 100%;margin-top:10px;"
        >
          <table
            class="team_table"
            style="width: 100%; box-shadow: 0px 7px 20px rgb(40 41 61 / 8%);    border: 1px solid lightgrey; font-size: 12px;margin-top:10px;"
          >
            <thead>
              <tr
                v-if="lipoPlatform.length > 0"
              >
                <th
                  v-for="(item, index) in lipoPlatform"
                  :key="index"
                  class="thClass"
                  style="border-radius: 10px 0px 0px 0px;"
                >
                  <span
                    :class="{
                      'green-text': item.numberOfPlannedEmployees === item.plannedEmployees.length,
                      'orange-text': item.numberOfPlannedEmployees < item.plannedEmployees.length,
                      'red-text': item.numberOfPlannedEmployees > item.plannedEmployees.length
                    }"
                  >
                    {{ item.storeName }} - {{ item.numberOfPlannedEmployees || 0 }}
                  </span>
                </th>
              </tr>
              <tr v-else>
                <th
                  class="thClass"
                  style="border-radius: 10px 0px 0px 0px;"
                >
                  {{ $t('Store') }}
                </th>
              </tr>
            </thead>

            <tbody>
              <tr v-if="lipoPlatform.length > 0">
                <td
                  v-for="(item, index) in lipoPlatform"
                  :key="index"
                  class="thClass"
                  style="border-radius: 10px 0px 0px 0px;"
                >
                  <div v-if="item.plannedEmployees.length > 0">
                    <p
                      v-for="(emplooye ,employeeIndex) in item.plannedEmployees"
                      :key="employeeIndex"
                      class="header"
                      :style="{ background: emplooye.employeeType === 'Internal' ? 'rgb(143, 188, 143)' : 'rgb(255, 215, 0)' }"
                    >
                      {{ emplooye.employeeName }}
                      <span style="display:flex;gap:5px;">
                        <b-icon-pencil-fill
                          v-b-modal.new-edit-employee-platform
                          style="cursor:pointer"
                          @click="editEmployee(emplooye, platformLipoName, item.storeName, item.startDate, item.endDate)"
                        />
                        <b-icon-trash-fill
                          v-b-modal.new-delete-employee-platform
                          style="cursor:pointer"
                          @click="deleteEmploye(emplooye, platformLipoName, item.storeName, item.startDate, item.endDate)"
                        />
                      </span>
                    </p>
                  </div>
                  <div
                    v-else
                    class="header"
                    style="background-color: red;color:white;"
                  >
                    <p>
                      {{ $t('NoEmployeeFound') }}
                    </p>
                  </div>
                </td>
              </tr>
              <tr v-else>
                <td
                  class="thClass"
                  style="border-radius: 10px 0px 0px 0px;"
                >
                  {{ $t('NoEmployeeFound') }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-collapse>
    </div>
    <div
      v-show="platformPfinster"
      style="margin-top: 25px;border:1px solid lightgrey;padding:10px;border-radius:12px;"
    >
      <div style="display:flex;justify-content: flex-end;align-items: center;">
        <b-form-group
          v-if="!pfinsterCollapsed"
          style="width:250px"
        >
          <b-form-input
            v-model="platformPfinsterName"
            disabled
          />
        </b-form-group>
        <b-icon-chevron-down
          v-if="!pfinsterCollapsed"
          style="cursor:pointer; margin-left: 10px;"
          @click="toggleCollapse('pfinsterCollapsed')"
        />
        <b-icon-chevron-up
          v-if="pfinsterCollapsed"
          style="cursor:pointer; margin-left: 10px;"
          @click="toggleCollapse('pfinsterCollapsed')"
        />
      </div>
      <b-collapse
        :visible="pfinsterCollapsed"
        class="mt-2"
      >
        <div style="display: flex;justify-content: space-between;">
          <div style="display:flex; gap:10px;align-items: end;">
            <b-form-group
              :label="$t('Platform')"
              style="width:250px"
            >
              <b-form-input
                v-model="platformPfinsterName"
                disabled
              />
            </b-form-group>
            <button
              v-b-modal.new-add-employee-planning
              class="button"
              style="border-radius: 6px; height: 36px; margin-top: 25px; margin-right: 20px; width:200px"
              @click="fetchStores(platformPfinsterName)"
            >
              <b-icon-plus />
              {{ $t('Employee') }}
            </button>
          </div>
          <b-form-group
            :label="$t('Date')"
          >
            <div style="display:flex;gap:5px;">
              <button
                class="buttonArrays"
                @click="previousDay('startDatePfinster')"
              >
                <b-icon-arrow-left />
              </button>
              <date-picker
                v-model="startDatePfinster"
                type="date"
                value-type="format"
                :placeholder="$t('SelectDate')"
                :format="'YYYY-MM-DD'"
                :start-day="1"
                :lang="lang"
                :clearable="false"
              />
              <button
                class="buttonArrays"
                @click="nextDay('startDatePfinster')"
              >
                <b-icon-arrow-right />
              </button>
            </div>
          </b-form-group>
        </div>
        <div
          style="overflow-x: auto;width: 100%;margin-top:10px;"
        >
          <table
            class="team_table"
            style="width: 100%; box-shadow: 0px 7px 20px rgb(40 41 61 / 8%);    border: 1px solid lightgrey; font-size: 12px;margin-top:10px;"
          >
            <thead>
              <tr
                v-if="pfinsterPlatform.length > 0"
              >
                <th
                  v-for="(item, index) in pfinsterPlatform"
                  :key="index"
                  class="thClass"
                  style="border-radius: 10px 0px 0px 0px;"
                >
                  <span
                    :class="{
                      'green-text': item.numberOfPlannedEmployees === item.plannedEmployees.length,
                      'orange-text': item.numberOfPlannedEmployees < item.plannedEmployees.length,
                      'red-text': item.numberOfPlannedEmployees > item.plannedEmployees.length
                    }"
                  >
                    {{ item.storeName }} - {{ item.numberOfPlannedEmployees || 0 }}
                  </span>
                </th>
              </tr>
              <tr v-else>
                <th
                  class="thClass"
                  style="border-radius: 10px 0px 0px 0px;"
                >
                  {{ $t('Store') }}
                </th>
              </tr>
            </thead>

            <tbody>
              <tr v-if="pfinsterPlatform.length > 0">
                <td
                  v-for="(item, index) in pfinsterPlatform"
                  :key="index"
                  class="thClass"
                  style="border-radius: 10px 0px 0px 0px;"
                >
                  <div v-if="item.plannedEmployees.length > 0">
                    <p
                      v-for="(emplooye ,employeeIndex) in item.plannedEmployees"
                      :key="employeeIndex"
                      class="header"
                      :style="{ background: emplooye.employeeType === 'Internal' ? 'rgb(143, 188, 143)' : 'rgb(255, 215, 0)' }"
                    >
                      {{ emplooye.employeeName }}
                      <span style="display:flex;gap:5px;">
                        <b-icon-pencil-fill
                          v-b-modal.new-edit-employee-platform
                          style="cursor:pointer"
                          @click="editEmployee(emplooye, platformPfinsterName, item.storeName, item.startDate, item.endDate)"
                        />
                        <b-icon-trash-fill
                          v-b-modal.new-delete-employee-platform
                          style="cursor:pointer"
                          @click="deleteEmploye(emplooye, platformPfinsterName, item.storeName, item.startDate, item.endDate)"
                        />
                      </span>
                    </p>
                  </div>
                  <div
                    v-else
                    class="header"
                    style="background-color: red;color:white;"
                  >
                    <p>
                      {{ $t('NoEmployeeFound') }}
                    </p>
                  </div>
                </td>
              </tr>
              <tr v-else>
                <td
                  class="thClass"
                  style="border-radius: 10px 0px 0px 0px;"
                >
                  {{ $t('NoEmployeeFound') }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      </b-collapse>
    </div>
    <div
      v-show="platformMoemax"
      style="margin-top: 25px;border:1px solid lightgrey;padding:10px;border-radius:12px;"
    >
      <div style="display:flex;justify-content: flex-end;align-items: center;">
        <b-form-group
          v-if="!moemaxCollapsed"
          style="width:250px"
        >
          <b-form-input
            v-model="platformMoemaxName"
            disabled
          />
        </b-form-group>
        <b-icon-chevron-down
          v-if="!moemaxCollapsed"
          style="cursor:pointer; margin-left: 10px;"
          @click="toggleCollapse('moemaxCollapsed')"
        />
        <b-icon-chevron-up
          v-if="moemaxCollapsed"
          style="cursor:pointer; margin-left: 10px;"
          @click="toggleCollapse('moemaxCollapsed')"
        />
      </div>
      <b-collapse
        :visible="moemaxCollapsed"
        class="mt-2"
      >
        <div style="display: flex;justify-content: space-between;">
          <div style="display:flex; gap:10px;align-items: end;">
            <b-form-group
              :label="$t('Platform')"
              style="width:250px"
            >
              <b-form-input
                v-model="platformMoemaxName"
                disabled
              />
            </b-form-group>
            <button
              v-b-modal.new-add-employee-planning
              class="button"
              style="border-radius: 6px; height: 36px; margin-top: 25px; margin-right: 20px; width:200px"
              @click="fetchStores(platformMoemaxName)"
            >
              <b-icon-plus />
              {{ $t('Employee') }}
            </button>
          </div>
          <b-form-group
            :label="$t('Date')"
          >
            <div style="display:flex;gap:5px;">
              <button
                class="buttonArrays"
                @click="previousDay('startDateMoemax')"
              >
                <b-icon-arrow-left />
              </button>
              <date-picker
                v-model="startDateMoemax"
                type="date"
                value-type="format"
                :placeholder="$t('SelectDate')"
                :format="'YYYY-MM-DD'"
                :start-day="1"
                :lang="lang"
                :clearable="false"
              />
              <button
                class="buttonArrays"
                @click="nextDay('startDateMoemax')"
              >
                <b-icon-arrow-right />
              </button>
            </div>
          </b-form-group>
        </div>
        <div
          style="overflow-x: auto;width: 100%;margin-top:10px;"
        >
          <table
            class="team_table"
            style="width: 100%; box-shadow: 0px 7px 20px rgb(40 41 61 / 8%);    border: 1px solid lightgrey; font-size: 12px;margin-top:10px;"
          >
            <thead>
              <tr
                v-if="moemaxPlatform.length > 0"
              >
                <th
                  v-for="(item, index) in moemaxPlatform"
                  :key="index"
                  class="thClass"
                  style="border-radius: 10px 0px 0px 0px;"
                >
                  <span
                    :class="{
                      'green-text': item.numberOfPlannedEmployees === item.plannedEmployees.length,
                      'orange-text': item.numberOfPlannedEmployees < item.plannedEmployees.length,
                      'red-text': item.numberOfPlannedEmployees > item.plannedEmployees.length
                    }"
                  >
                    {{ item.storeName }} - {{ item.numberOfPlannedEmployees || 0 }}
                  </span>
                </th>
              </tr>
              <tr v-else>
                <th
                  class="thClass"
                  style="border-radius: 10px 0px 0px 0px;"
                >
                  {{ $t('Store') }}
                </th>
              </tr>
            </thead>

            <tbody>
              <tr v-if="moemaxPlatform.length > 0">
                <td
                  v-for="(item, index) in moemaxPlatform"
                  :key="index"
                  class="thClass"
                  style="border-radius: 10px 0px 0px 0px;"
                >
                  <div v-if="item.plannedEmployees.length > 0">
                    <p
                      v-for="(emplooye ,employeeIndex) in item.plannedEmployees"
                      :key="employeeIndex"
                      class="header"
                      :style="{ background: emplooye.employeeType === 'Internal' ? 'rgb(143, 188, 143)' : 'rgb(255, 215, 0)' }"
                    >
                      {{ emplooye.employeeName }}
                      <span style="display:flex;gap:5px;">
                        <b-icon-pencil-fill
                          v-b-modal.new-edit-employee-platform
                          style="cursor:pointer"
                          @click="editEmployee(emplooye, platformMoemaxName, item.storeName, item.startDate, item.endDate)"
                        />
                        <b-icon-trash-fill
                          v-b-modal.new-delete-employee-platform
                          style="cursor:pointer"
                          @click="deleteEmploye(emplooye, platformMoemaxName, item.storeName, item.startDate, item.endDate)"
                        />
                      </span>
                    </p>
                  </div>
                  <div
                    v-else
                    class="header"
                    style="background-color: red;color:white;"
                  >
                    <p>
                      {{ $t('NoEmployeeFound') }}
                    </p>
                  </div>
                </td>
              </tr>
              <tr v-else>
                <td
                  class="thClass"
                  style="border-radius: 10px 0px 0px 0px;"
                >
                  {{ $t('NoStoreFound') }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      </b-collapse>
    </div>

    <div
      style="margin-top: 25px;border:1px solid lightgrey;padding:10px;border-radius:12px;"
    >
      <div style="display:flex;justify-content: flex-end;align-items: center;">
        <p
          v-if="!vacationCollapsed"
          style="margin-bottom: 0px;color:black;"
        >{{ $t('VacationsEmployeesNow') }}</p>
        <b-icon-chevron-down
          v-if="!vacationCollapsed"
          style="cursor:pointer; margin-left: 10px;"
          @click="toggleCollapse('vacationCollapsed')"
        />
        <b-icon-chevron-up
          v-if="vacationCollapsed"
          style="cursor:pointer; margin-left: 10px;"
          @click="toggleCollapse('vacationCollapsed')"
        />
      </div>

      <b-collapse
        :visible="vacationCollapsed"
        class="mt-2"
      >
        <div style="display: flex;justify-content: center;gap:10px;align-items:end;">
          <b-form-group
            :label="$t('Date')"
          >
            <div style="display:flex;gap:5px;">
              <button
                class="buttonArrays"
                @click="previousDayVacation()"
              >
                <b-icon-arrow-left />
              </button>
              <date-picker
                v-model="startDateVacation"
                type="date"
                value-type="format"
                :placeholder="$t('SelectDate')"
                :format="'YYYY-MM-DD'"
                :start-day="1"
                :lang="lang"
                :clearable="false"
              />
              <button
                class="buttonArrays"
                @click="nextDayVacation()"
              >
                <b-icon-arrow-right />
              </button>
            </div>
          </b-form-group>
        </div>
        <div
          style="overflow-x: auto;width: 100%;margin-top:10px;"
        >
          <table
            class="team_table"
            style="width: 100%; box-shadow: 0px 7px 20px rgb(40 41 61 / 8%);    border: 1px solid lightgrey; font-size: 12px;margin-top:10px;"
          >
            <thead>
              <tr>
                <th class="thClass">
                  {{ $t('EmployeeName') }}
                </th>
                <th class="thClass">
                  {{ $t('VacationType') }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) in getVacationsOverviewPlatforms?.storeDailyVacation"
                :key="index"
              >
                <td
                  class="thClass"
                  style="border-radius: 10px 0px 0px 0px;"
                >
                  {{ item.fullName }}
                </td>
                <td
                  class="thClass"
                  style="border-radius: 10px 0px 0px 0px;"
                >
                  {{ item.vacationType }}
                </td>
              </tr>
              <tr
                v-if="getVacationsOverviewPlatforms?.storeDailyVacation.length == 0"
              >
                <td
                  class="thClass"
                  style="border-radius: 10px 0px 0px 0px;border-right: none;"
                >
                  {{ $t('NoEmployeeFound') }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-collapse>

    </div>

    <NewAddEmployeesPlanning
      :platform-name="platformName"
      @addPersonalPlanning="addPersonalPlannings"
    />
    <NewEditEmployeePlanning
      :platform-name="platformName"
      :employee-name="employeeName"
      :store-name="storeName"
      @editEmployeePlanning="editEmployeePlannings"
    />
    <NewDeleteEmployeePlanning
      :platform-name="platformName"
      :employee-name="employeeName"
      :store-name="storeName"
      @deleteEmployeePlanning="deleteEmployeePlannings"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import moment from 'moment'
import NewAddEmployeesPlanning from '@/components/employees/modals/NewAddEmployeesPlaning.vue'
import NewEditEmployeePlanning from './employees/modals/NewEditEmployeePlanning.vue';
import NewDeleteEmployeePlanning from './employees/modals/NewDeleteEmployeePlanning.vue';

export default {
  components: {
    DatePicker,
    NewAddEmployeesPlanning,
    NewEditEmployeePlanning,
    NewDeleteEmployeePlanning,
  },

  data() {
    return {
      startDateForAll: moment().format('YYYY-MM-DD'),
      vacationCollapsed: true,
      startDateVacation: moment().format('YYYY-MM-DD'),
      storeName: null,
      conforamaCollapsed: true,
      moemaxCollapsed: true,
      lipoCollapsed: true,
      pfinsterCollapsed: true,
      platformMoemax: false,
      platformPfinster: false,
      platformLipo: false,
      platformConforama: true,
      startDateConforama: moment().format('YYYY-MM-DD'),
      startDateMoemax: moment().format('YYYY-MM-DD'),
      startDateLipo: moment().format('YYYY-MM-DD'),
      startDatePfinster: moment().format('YYYY-MM-DD'),
      lang: {
        formatLocale: {
          firstDayOfWeek: 1,
        },
        monthBeforeYear: false,
      },
      platformMoemaxName: 'Moemax',
      platformPfinsterName: 'Pfister',
      platformLipoName: 'Lipo',
      platformConforamaName: 'Conforama',
      conforamaPlatform: [],
      lipoPlatform: [],
      moemaxPlatform: [],
      pfinsterPlatform: [],
      platformName: null,
      employeeName: null,
    };
  },
  computed: {
    ...mapGetters(['getVacationsOverviewPlatforms']),
  },
  watch: {
    startDateVacation(value) {
      if (value) {
        this.loadAllVacationsOverview({
          date: moment(value).format('YYYY-MM-DD'),
        })
      }
    },
    startDateConforama(value) {
      if (value) {
        const startDate = moment(value).format('YYYY-MM-DDT08:00:00.SSSZ')
        const endDate = moment(value).format('YYYY-MM-DDT17:00:00.SSSZ')
        this.loadPersonalPlanning({
          platform: 'Conforama',
          startDate,
          endDate,
          isCarpenter: false,
        }).then((response) => {
          this.conforamaPlatform = response
        })
          .catch((error) => {
            console.error('Error loading personal planning:', error);
          });
      }
    },
    startDateMoemax(value) {
      if (value) {
        const startDate = moment(value).format('YYYY-MM-DDT08:00:00.SSSZ')
        const endDate = moment(value).format('YYYY-MM-DDT17:00:00.SSSZ')
        this.loadPersonalPlanning({
          platform: 'Moemax',
          startDate,
          endDate,
          isCarpenter: false,
        }).then((response) => {
          this.moemaxPlatform = response
        })
          .catch((error) => {
            console.error('Error loading personal planning:', error);
          });
      }
    },
    startDateLipo(value) {
      if (value) {
        const startDate = moment(value).format('YYYY-MM-DDT08:00:00.SSSZ')
        const endDate = moment(value).format('YYYY-MM-DDT17:00:00.SSSZ')
        this.loadPersonalPlanning({
          platform: 'Lipo',
          startDate,
          endDate,
          isCarpenter: false,
        }).then((response) => {
          this.lipoPlatform = response
        })
          .catch((error) => {
            console.error('Error loading personal planning:', error);
          });
      }
    },
    startDatePfinster(value) {
      if (value) {
        const startDate = moment(value).format('YYYY-MM-DDT08:00:00.SSSZ')
        const endDate = moment(value).format('YYYY-MM-DDT17:00:00.SSSZ')
        this.loadPersonalPlanning({
          platform: 'Pfister',
          startDate,
          endDate,
          isCarpenter: false,
        }).then((response) => {
          this.pfinsterPlatform = response
        })
          .catch((error) => {
            console.error('Error loading personal planning:', error);
          });
      }
    },
  },
  mounted() {
    this.loadAllVacationsOverview({
      date: moment().format('YYYY-MM-DD'),
    })
    this.loadPersonalPlanning({
      platform: 'Conforama',
      startDate: moment().format('YYYY-MM-DDT08:00:00.SSSZ'),
      endDate: moment().format('YYYY-MM-DDT17:00:00.SSSZ'),
      isCarpenter: false,
    })
      .then((response) => {
        this.conforamaPlatform = response
      })
      .catch((error) => {
        console.error('Error loading personal planning:', error);
      });
  },
  methods: {
    ...mapActions(['loadPersonalPlanning', 'loadAllVacationsOverview', 'deleteEmployeePlanning', 'editEmployeePlanning', 'freeEmployees_new_Platform', 'loadFilialeByPlatform', 'loadFilialePagination', 'addEmployeePlanning']),
    deleteEmployeePlannings(value) {
      this.deleteEmployeePlanning({
        employeePlanId: value,
        successCallback: () => {
          const startDateKey = `startDate${this.platformName}`;
          const startDate = this[startDateKey]
          const startDate1 = moment(startDate).format('YYYY-MM-DDT08:00:00.SSSZ')
          const endDate1 = moment(startDate).format('YYYY-MM-DDT17:00:00.SSSZ')
          this.loadPersonalPlanning({
            platform: this.platformName,
            startDate: startDate1,
            endDate: endDate1,
            isCarpenter: false,
          })
            .then((response) => {
              if (this.platformName === 'Conforama') {
                this.conforamaPlatform = response;
              } else if (this.platformName === 'Moemax') {
                this.moemaxPlatform = response;
              } else if (this.platformName === 'Lipo') {
                this.lipoPlatform = response;
              } else if (this.platformName === 'Pfister') {
                this.pfinsterPlatform = response;
              }
            })
            .catch((error) => {
              console.error('Error loading personal planning:', error);
            });
        },
      })
    },
    editEmployeePlannings(value) {
      this.editEmployeePlanning({
        obj: value,
        successCallback: () => {
          const startDateKey = `startDate${this.platformName}`;
          const startDate = this[startDateKey]
          const startDate1 = moment(startDate).format('YYYY-MM-DDT08:00:00.SSSZ')
          const endDate1 = moment(startDate).format('YYYY-MM-DDT17:00:00.SSSZ')
          this.loadPersonalPlanning({
            platform: this.platformName,
            startDate: startDate1,
            endDate: endDate1,
            isCarpenter: false,
          })
            .then((response) => {
              if (this.platformName === 'Conforama') {
                this.conforamaPlatform = response;
              } else if (this.platformName === 'Moemax') {
                this.moemaxPlatform = response;
              } else if (this.platformName === 'Lipo') {
                this.lipoPlatform = response;
              } else if (this.platformName === 'Pfister') {
                this.pfinsterPlatform = response;
              }
            })
            .catch((error) => {
              console.error('Error loading personal planning:', error);
            });
        },
      })
    },
    toggleCollapse(value) {
      this[value] = !this[value];
    },
    addPersonalPlannings(value) {
      this.addEmployeePlanning({
        object: value,
        successCallback: () => {
          const startDateKey = `startDate${this.platformName}`;
          const startDate = this[startDateKey]
          const startDate1 = moment(startDate).format('YYYY-MM-DDT08:00:00.SSSZ')
          const endDate1 = moment(startDate).format('YYYY-MM-DDT17:00:00.SSSZ')
          this.loadPersonalPlanning({
            platform: this.platformName,
            startDate: startDate1,
            endDate: endDate1,
            isCarpenter: false,
          }).then((response) => {
            if (this.platformName === 'Conforama') {
              this.conforamaPlatform = response;
            } else if (this.platformName === 'Moemax') {
              this.moemaxPlatform = response;
            } else if (this.platformName === 'Lipo') {
              this.lipoPlatform = response;
            } else if (this.platformName === 'Pfister') {
              this.pfinsterPlatform = response;
            }
          })
            .catch((error) => {
              console.error('Error loading personal planning:', error);
            });
        },
      })
    },
    fetchStores(value) {
      this.platformName = value
      this.loadFilialeByPlatform({
        platform: value,
      })
    },
    editEmployee(employee, valuePlatform, storeName, startDate, endDate) {
      this.platformName = valuePlatform
      this.employeeName = employee
      this.storeName = storeName
      this.freeEmployees_new_Platform({
        startShift: startDate,
        endShift: endDate,
      })
    },
    deleteEmploye(employee, valuePlatform, storeName) {
      this.platformName = valuePlatform
      this.employeeName = employee
      this.storeName = storeName
    },
    previousDayForAll(value) {
      this.startDateForAll = moment(value, 'YYYY-MM-DD').subtract(1, 'days').format('YYYY-MM-DD');
      if (this.platformConforama == true) {
        this.startDateConforama = moment(value, 'YYYY-MM-DD').subtract(1, 'days').format('YYYY-MM-DD');
      }
      if (this.platformMoemax == true) {
        this.startDateMoemax = moment(value, 'YYYY-MM-DD').subtract(1, 'days').format('YYYY-MM-DD');
      }
      if (this.platformLipo == true) {
        this.startDateLipo = moment(value, 'YYYY-MM-DD').subtract(1, 'days').format('YYYY-MM-DD');
      }
      if (this.platformPfinster) {
        this.startDatePfinster = moment(value, 'YYYY-MM-DD').subtract(1, 'days').format('YYYY-MM-DD');
      }
      this.startDateVacation = moment(value, 'YYYY-MM-DD').subtract(1, 'days').format('YYYY-MM-DD');
    },
    nextDayForAll(value) {
      this.startDateForAll = moment(value, 'YYYY-MM-DD').add(0.5, 'days').format('YYYY-MM-DD');
      if (this.platformConforama == true) {
        this.startDateConforama = moment(value, 'YYYY-MM-DD').add(0.5, 'days').format('YYYY-MM-DD');
      }
      if (this.platformMoemax == true) {
        this.startDateMoemax = moment(value, 'YYYY-MM-DD').add(0.5, 'days').format('YYYY-MM-DD');
      }
      if (this.platformLipo == true) {
        this.startDateLipo = moment(value, 'YYYY-MM-DD').add(0.5, 'days').format('YYYY-MM-DD');
      }
      if (this.platformPfinster) {
        this.startDatePfinster = moment(value, 'YYYY-MM-DD').add(0.5, 'days').format('YYYY-MM-DD');
      }
      this.startDateVacation = moment(value, 'YYYY-MM-DD').add(0.5, 'days').format('YYYY-MM-DD');
      // this.platformMoemax = true
      // this.platformPfinster = true
      // this.platformLipo = true
      // this.platformConforama = true
    },
    previousDay(value) {
      this[value] = moment(this[value], 'YYYY-MM-DD').subtract(1, 'days').format('YYYY-MM-DD');
    },
    nextDay(value) {
      this[value] = moment(this[value], 'YYYY-MM-DD').add(0.5, 'days').format('YYYY-MM-DD');
    },
    previousDayVacation() {
      this.startDateVacation = moment(this.startDateVacation, 'YYYY-MM-DD').subtract(1, 'days').format('YYYY-MM-DD');
    },
    nextDayVacation() {
      this.startDateVacation = moment(this.startDateVacation, 'YYYY-MM-DD').add(0.5, 'days').format('YYYY-MM-DD');
    },
    updatePlatforms(trueFalse, value, platformName) {
      if (trueFalse) {
        const startDateKey = `startDate${value}`;
        const startDate = this[startDateKey]
        const startDate1 = moment(startDate).format('YYYY-MM-DDT08:00:00.SSSZ')
        const endDate1 = moment(startDate).format('YYYY-MM-DDT17:00:00.SSSZ')
        this.loadPersonalPlanning({
          platform: value,
          startDate: startDate1,
          endDate: endDate1,
          isCarpenter: false,
        })
          .then((response) => {
            this[platformName] = response
          })
          .catch((error) => {
            console.error('Error loading personal planning:', error);
          });
      } else {
        this[platformName] = []
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  padding: 10px;
    text-align: left;
    border-radius: 5px;
    margin-top: 5px;
    display:flex;
    justify-content: space-between;
    align-items: center;

}
.thClass{
    padding: 10px;
    text-align: left;
    border-right:1px solid lightgrey;
}
.buttonArrays {
    width: 36px !important;
    height: 36px;
    display: flex;
    margin-right: 5px;
    border-radius: 6px !important;
    justify-content: center;
    border: #c3d0dd 1px solid;
    background-color: #e9ecef;
    align-items: center;
  }
  .green-text {
  color: rgb(52, 116, 3);
}

.orange-text {
  color: rgb(255, 155, 0);
}

.red-text {
  color: rgb(216, 37, 33);
}
</style>
